/* eslint-disable import/no-cycle */
import * as actionTypes from '~/store/actions/actionTypes';
import api from '~/services';
import * as lib from '~/dependencies';
import { log, mediaStreamMonitor } from '~/helpers';
import * as actions from './index';

export const phoneDeviceInitialSetup = deviceManager => ({
  type: actionTypes.PHONE_DEVICE_SETUP,
  deviceManager,
});

export const phoneDeviceChange = deviceManager => ({
  type: actionTypes.PHONE_DEVICE_CHANGE,
  deviceManager,
});

export const phoneDeviceSetup = () => (dispatch, getState) => {
  const { system } = getState();
  const userPreferences = system?.userPreferences?.audio;
  let microphone;
  let speaker;

  // This does an initial setup for default devices(Microphone and Speaker).
  // We're calling getUserMedia because
  // it need user authorization, otherwise, we can't get device label.
  navigator.mediaDevices
    .getUserMedia({ video: false, audio: true })
    .then(stream => {
      // Run through all devices identified by the browser
      navigator.mediaDevices
        .enumerateDevices()
        .then(systemPreferences => {
          const getDeviceInfo = device => {
            return {
              deviceId: device.deviceId,
              label: device.label,
              groupId: device.groupId,
            };
          };

          const getDefault = kind => {
            const defaults = getDeviceInfo(
              systemPreferences.find(
                e => e.kind === kind && e.deviceId === 'default'
              )
            );
            return defaults;
          };

          const selectedSpeaker = userPreferences?.speaker;
          const selectedMicro = userPreferences?.microphone;

          // If available system devices does not contains user preference device
          if (!selectedSpeaker?.label) {
            speaker = getDefault('audiooutput');
          } else if (
            !systemPreferences.some(
              item =>
                item.label === selectedSpeaker.label &&
                item.kind === 'audiooutput'
            )
          ) {
            speaker = getDefault('audiooutput');
          } else {
            speaker = selectedSpeaker;
          }

          if (!selectedMicro?.label) {
            microphone = getDefault('audioinput');
          } else if (
            !systemPreferences.some(
              item =>
                item.label === selectedSpeaker.label &&
                item.kind === 'audioinput'
            )
          ) {
            microphone = getDefault('audioinput');
          } else {
            microphone = selectedMicro;
          }

          // Stop all tracks
          stream.getTracks().forEach(track => track.stop());
          dispatch(phoneDeviceInitialSetup({ audio: { microphone, speaker } }));
        })
        .catch(err => {
          log.error('Failed to enumerate devices.', err);
        });
    })
    .catch(err => {
      log.error('Failed to get device stream.', err);
    });
};

export const systemSave = data => dispatch => {
  dispatch({
    type: actionTypes.SYSTEM_SAVE,
    payload: {
      machineId: data.machineId,
      OS: data.OS,
    },
  });
};

export const systemUpdateDateTime = () => dispatch => {
  dispatch({
    type: actionTypes.UPDATER_DATE_TIME,
    payload: {
      updaterDateTime: Date.now(),
    },
  });
};

export const changeUpdaterMessage = enable => dispatch => {
  dispatch({
    type: actionTypes.UPDATER_MESSAGE,
    payload: {
      showUpdaterMessage: enable,
    },
  });
};

/**
 * Change the system and phone status
 * @param {string} status - A new status could be Busy, Available or Unavailable
 */
export const statusSystem = newStatus => dispatch => {
  // const { isRegistered } = getState().phone;
  // const hasCurrentCalls = getState().callCurrent.data.length;

  // if (newStatus === 'Busy' && isRegistered && !hasCurrentCalls) {
  //   dispatch(actions.unRegisterSession());
  // }

  // if (newStatus === 'Available' && !isRegistered) {
  //   setTimeout(() => {
  //     dispatch(actions.registerSession());
  //   }, 3500);
  // }

  dispatch({
    type: actionTypes.STATUS_SYSTEM,
    payload: {
      status: newStatus,
    },
  });

  // dispatch(actions.changeStatus(newStatus));
};

export const devMode = value => async dispatch => {
  dispatch({
    type: actionTypes.DEV_MODE,
    payload: {
      dev: value,
    },
  });
  await dispatch(actions.unRegisterSession());
  dispatch(actions.startUA());
  // dispatch(actions.registerSession());
};

export const Console = value => dispatch => {
  dispatch({
    type: actionTypes.CONSOLE,
    payload: {
      console: value,
    },
  });
  localStorage.setItem('@consoleLog', value);
  // dispatch(actions.unRegisterSession());
  dispatch(actions.registerSession());
};

export const setLastHistoryCheck = () => dispatch => {
  const today = new Date();
  const dateNow = lib.dayjs(today).format('YYYY-MM-DD HH:mm:ss');

  dispatch({
    type: actionTypes.CHECKED_HISTORY,
    payload: {
      lastHistoryCheck: dateNow,
    },
  });
};

export const checkForUpdates = (userInteraction = false) => dispatch => {
  const today = new Date();
  const dateNow = lib.dayjs(today).format('YYYY-MM-DD HH:mm:ss');

  if (!userInteraction) {
    dispatch({
      type: actionTypes.CHECK_UPDATE,
      payload: {
        checkForUpdates: dateNow,
      },
    });
  } else {
    dispatch({
      type: actionTypes.USER_INTERACTION_UPDATE_DIALOG,
      payload: {
        userInteraction: dateNow,
      },
    });
  }
};

export const checkUpdater = () => dispatch => {
  api.system
    .checkUpdates()
    .then(response => {
      const resp = response.data;
      dispatch({
        type: actionTypes.NEW_VERSION_AVAILABLE,
        payload: {
          newVersionAvailable: resp,
        },
      });
    })
    .catch(err => {
      log.error('Failed to execute the checkUpdater action.', err);
    });
};

export const lastCheckContacts = (
  lastRequestedContacts,
  value = false
) => dispatch => {
  const today = new Date();
  const dateNow = lib.dayjs(today).format('YYYY-MM-DD HH:mm:ss');

  dispatch({
    type: actionTypes.CHECKED_CONTACTS,
    payload: {
      lastSeenContacts: dateNow,
      checkedContacts: value,
      lastRequestedContacts,
    },
  });
};

export const setVersion = value => dispatch => {
  dispatch({
    type: actionTypes.SET_VERSION,
    payload: {
      version: value,
    },
  });
};

export const transferPreference = value => dispatch => {
  dispatch({
    type: actionTypes.TRANSFER_PREFERENCE,
    payload: {
      transfer: value,
    },
  });
};

export const ringDeviceSelect = value => dispatch => {
  dispatch({
    type: actionTypes.RING_DEVICE,
    payload: {
      ringDevice: value,
    },
  });
};

export const changeRingTone = (value, internalRingtone) => dispatch => {
  dispatch({
    type: actionTypes.CHANGE_RINGTONE,
    payload: {
      ringTone: value,
      internalRingtone,
    },
  });
};

export const saveStatusSound = ({
  ringTone,
  outgoingRing,
  endTone,
  busyTone,
  bipTone,
}) => dispatch => {
  dispatch({
    type: actionTypes.STATUS_SOUNDS,
    payload: {
      statusSound: {
        ringTone,
        outgoingRing,
        endTone,
        busyTone,
        bipTone,
      },
    },
  });
};

export const UpdateDeviceRingTone = device => (dispatch, getState) => {
  const { system } = getState();
  const newValues = system.sounds;
  newValues.ringTone.src.setSinkId(device);
  newValues.outgoingRing.src.setSinkId(device);

  dispatch({
    type: actionTypes.UPDATE_SOUNDS_DEVICE,
    payload: {
      sounds: {
        ...newValues,
      },
    },
  });
};

export const PlayRing = (type, play) => (dispatch, getState) => {
  const { system, callCurrent } = getState();
  const { statusSound, ringTone } = system;
  const { session } = callCurrent;

  const nextStatusSound = { ...statusSound };

  // Don't play endTone if there is an active call or it is silent.
  if (statusSound) {
    if (
      (type === 'endTone' && session) ||
      (type === 'endTone' && ringTone === 'silence') ||
      (type === 'busyTone' && ringTone === 'silence')
    ) {
      nextStatusSound[type] = false;
    } else {
      nextStatusSound[type] = play;
    }
  }
  dispatch({
    type: actionTypes.STATUS_SOUNDS,
    payload: {
      statusSound: {
        ...nextStatusSound,
      },
    },
  });
};

export const remoteVideo = src => dispatch => {
  dispatch({
    type: actionTypes.SET_REMOTE_VIDEO,
    payload: {
      remoteVideo: src || {},
    },
  });
};

export const localVideo = src => dispatch => {
  dispatch({
    type: actionTypes.SET_LOCAL_VIDEO,
    payload: {
      localVideo: src || {},
    },
  });
};

export const addLocalVideo = mediaStream => dispatch => {
  dispatch({
    type: actionTypes.SET_LOCAL_VIDEO,
    payload: {
      localVideo: mediaStream,
    },
  });
};

export const clearAllMediaStream = () => (dispatch, getState) => {
  const { system } = getState();

  try {
    mediaStreamMonitor.clearMediaStreams();
  } catch (err) {
    log.error('Failed to stop and clean up media streams.', err);
  }

  if (system?.remoteVideo?.id) {
    dispatch(remoteVideo(null));
  }
  if (system?.localVideo?.id) {
    dispatch(localVideo(null));
  }
};

export const volumeControl = value => dispatch => {
  dispatch({
    type: actionTypes.SET_VOLUME,
    payload: {
      volume: value,
    },
  });
};

export const numberToTransfer = (value = null) => dispatch => {
  dispatch({
    type: actionTypes.NUMBER_TO_TRANSFER,
    payload: {
      numberToTransfer: value,
    },
  });
};

export const setLastDialedNumber = value => dispatch => {
  dispatch({
    type: actionTypes.SET_LAST_DIALED_NUMBER,
    payload: {
      lastDialedNumber: value,
    },
  });
};

export const numberContactToTransfer = (value = null) => dispatch => {
  dispatch({
    type: actionTypes.NUMBER_CONTACT_TO_TRANSFER,
    payload: {
      numberContactToTransfer: value,
    },
  });
};

export const addCallerIdCountryCode = value => dispatch => {
  dispatch({
    type: actionTypes.CALLER_ID_COUNTRY_CODE,
    payload: {
      callerIdCountryCode: value,
    },
  });
};

export const addTemporaryCountryCode = (value, isoCode) => dispatch => {
  dispatch({
    type: actionTypes.TEMPORARY_COUNTRY_CODE,
    payload: {
      temporaryCountryCode: value,
      temporaryISOCode: isoCode,
    },
  });
};

export const resetSystem = () => dispatch => {
  dispatch({ type: actionTypes.RESET_SYSTEM });
};

export const setStartOnBoot = startOnBoot => dispatch => {
  dispatch({
    type: actionTypes.START_ON_BOOT,
    payload: {
      startOnBoot,
    },
  });
};

export const setCallWaitingSound = callWaitingSound => dispatch => {
  dispatch({
    type: actionTypes.SET_CALL_WAITING_SOUND,
    payload: {
      callWaitingSound,
    },
  });
};

export const setSmsTermAccepted = viewed => dispatch => {
  dispatch({
    type: actionTypes.SET_ACCOUNT_SMS_BILLING_VIEWED,
    smsTermAccepted: viewed,
  });
};

export const setDisableKeypadTone = enable => dispatch => {
  dispatch({
    type: actionTypes.DISABLE_KEYPAD_TONE,
    payload: {
      disableKeypadTone: enable,
    },
  });
};

export const setIsBusy = isBusy => dispatch => {
  dispatch({
    type: actionTypes.SET_SYSTEM_IS_BUSY,
    payload: { isBusy },
  });
};

export const resetStates = () => dispatch => {
  dispatch(actions.resetPhones());
  dispatch(actions.resetCalls());
  dispatch(actions.resetContacts());
  dispatch(actions.resetCallsCurrent());
  dispatch(actions.resetStatus());
  dispatch(actions.resetSystem());
  dispatch(actions.resetAuth());
  dispatch(actions.resetConversations());
};
